import React, { useState, useEffect } from "react";

import logo from "../../images/header/logo.png";
import bigLogo from "../../images/header/bigLogo.png";
import useWindowDimensions from "../../useWindowDimensions";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "./../Button/Button";
import ReactFlagkit from "react-flagkit";
import { Row, Col, Image } from "antd";

import Select, { components } from "react-select";
import usSvg from "../../images/header/us.svg";
import malaysiaSvg from "../../images/header/malaysia.svg";
import dutchSvg from "../../images/header/dutch.svg";

import chinaSvg from "../../images/header/china.svg";

import "./style.less";

const options = [
  { value: "en", label: "English", countryCode: "US", src: usSvg },
  { value: "ml", label: "Malay", countryCode: "MY", src: malaysiaSvg },
  { value: "md", label: "Mandarin", countryCode: "CN", src: chinaSvg },
  { value: "dt", label: "Dutch", countryCode: "NL", src: dutchSvg },
  // Add more language options as needed
];

// const options = [
// 	{
// 		value: 'England',
// 		label: 'England',
// 		src: usSvg,
// 	},
// 	{ value: 'Germany', label: 'Germany', src: malaysiaSvg },
// ]
// const customStyles = {
// 	option: (provided, state) => ({
// 		...provided,
// 		padding: 5,
// 	}),
// 	singleValue: (provided, state) => ({
// 		...provided,
// 		padding: 5,
// 	}),
// }

const customStyles = {
  control: (provided) => ({
    ...provided,
    border: "none",
  }),
  option: (provided) => ({
    ...provided,
    borderBottom: "1px solid #ccc",
    padding: 5,
  }),
};

const { Option } = components;

const linkStyle = {
  paddingTop: "1em",
  // margin: "0.5em",
  textDecoration: "none",
  color: "  #1A202C",
};

const CommonHeader = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="ogHeader">
      <Row className="firstrow j-c a-c">
        <Col span={12} sm={12} xs={12} className="firstCol">
          <div className="left d-f  a-c">
            <svg
              width="15"
              height="15"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0007 1.66669C8.24403 1.6666 6.55836 2.35982 5.31002 3.59568C4.06168 4.83154 3.35155 6.51016 3.33398 8.26669C3.33398 12.8334 9.20898 17.9167 9.45898 18.1334C9.60993 18.2625 9.80202 18.3334 10.0007 18.3334C10.1993 18.3334 10.3914 18.2625 10.5423 18.1334C10.834 17.9167 16.6673 12.8334 16.6673 8.26669C16.6498 6.51016 15.9396 4.83154 14.6913 3.59568C13.4429 2.35982 11.7573 1.6666 10.0007 1.66669ZM10.0007 16.375C8.60898 15.05 5.00065 11.375 5.00065 8.26669C5.00065 6.9406 5.52744 5.66884 6.46512 4.73115C7.4028 3.79347 8.67457 3.26669 10.0007 3.26669C11.3267 3.26669 12.5985 3.79347 13.5362 4.73115C14.4739 5.66884 15.0007 6.9406 15.0007 8.26669C15.0007 11.35 11.3923 15.05 10.0007 16.375Z"
                fill="white"
              />
              <path
                d="M10.0007 5C9.42379 5 8.85988 5.17106 8.38024 5.49155C7.9006 5.81203 7.52676 6.26756 7.306 6.80051C7.08525 7.33346 7.02749 7.9199 7.14003 8.48568C7.25257 9.05146 7.53035 9.57116 7.93826 9.97906C8.34616 10.387 8.86586 10.6648 9.43164 10.7773C9.99742 10.8898 10.5839 10.8321 11.1168 10.6113C11.6498 10.3906 12.1053 10.0167 12.4258 9.53708C12.7463 9.05744 12.9173 8.49353 12.9173 7.91667C12.9173 7.14312 12.61 6.40125 12.063 5.85427C11.5161 5.30729 10.7742 5 10.0007 5ZM10.0007 9.16667C9.75343 9.16667 9.51175 9.09336 9.30619 8.956C9.10063 8.81865 8.94041 8.62343 8.8458 8.39502C8.75119 8.16661 8.72644 7.91528 8.77467 7.6728C8.8229 7.43033 8.94195 7.2076 9.11677 7.03278C9.29158 6.85797 9.51431 6.73892 9.75679 6.69068C9.99927 6.64245 10.2506 6.66721 10.479 6.76182C10.7074 6.85643 10.9026 7.01664 11.04 7.2222C11.1773 7.42777 11.2507 7.66944 11.2507 7.91667C11.2507 8.24819 11.119 8.56613 10.8845 8.80055C10.6501 9.03497 10.3322 9.16667 10.0007 9.16667Z"
                fill="white"
              />
            </svg>
            &nbsp; <div className="txt">{t("headers.location")}</div>
          </div>
          <div className="left second d-f a-c">
            <svg
              width="15"
              height="15"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.2501 18.125H16.1438C3.86259 17.4187 2.11884 7.05625 1.87509 3.89375C1.85545 3.64786 1.88452 3.40052 1.96064 3.16588C2.03676 2.93125 2.15842 2.71394 2.31867 2.52641C2.47891 2.33888 2.67458 2.1848 2.89448 2.07302C3.11437 1.96124 3.35415 1.89395 3.60009 1.875H7.04384C7.29419 1.87476 7.53885 1.94969 7.74611 2.0901C7.95338 2.23051 8.11372 2.42992 8.20634 2.6625L9.15634 5C9.24781 5.22722 9.27051 5.4763 9.22162 5.71631C9.17273 5.95631 9.05441 6.17667 8.88134 6.35L7.55009 7.69375C7.75804 8.87547 8.32396 9.96479 9.17128 10.8143C10.0186 11.6639 11.1064 12.2327 12.2876 12.4438L13.6438 11.1C13.8198 10.9288 14.0422 10.8133 14.2834 10.7677C14.5246 10.7221 14.7738 10.7486 15.0001 10.8438L17.3563 11.7875C17.5854 11.8831 17.7809 12.0446 17.9178 12.2517C18.0547 12.4587 18.1269 12.7018 18.1251 12.95V16.25C18.1251 16.7473 17.9276 17.2242 17.5759 17.5758C17.2243 17.9275 16.7474 18.125 16.2501 18.125ZM3.75009 3.125C3.58433 3.125 3.42536 3.19085 3.30815 3.30806C3.19094 3.42527 3.12509 3.58424 3.12509 3.75V3.8C3.41259 7.5 5.25634 16.25 16.2126 16.875C16.2947 16.8801 16.377 16.8689 16.4548 16.8421C16.5326 16.8153 16.6043 16.7734 16.6658 16.7188C16.7274 16.6642 16.7775 16.598 16.8135 16.524C16.8494 16.45 16.8703 16.3696 16.8751 16.2875V12.95L14.5188 12.0062L12.7251 13.7875L12.4251 13.75C6.98759 13.0688 6.25009 7.63125 6.25009 7.575L6.21259 7.275L7.98759 5.48125L7.05009 3.125H3.75009Z"
                fill="white"
              />
            </svg>
            &nbsp;
            <a href="tel:+60122790196">+60 122790196</a>
          </div>
        </Col>
        <Col lg={12} sm={12} xs={12}>
          <div className="right">
            <a href="https://me-qr.com/9zJ40pVd">
              <svg
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.6667 9.99998L8.75 11.6666V8.33331L11.6667 9.99998Z"
                  fill="white"
                  stroke="white"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.66602 10.5891V9.40998C1.66602 6.99748 1.66602 5.79081 2.42018 5.01498C3.17518 4.23831 4.36352 4.20498 6.73935 4.13748C7.86435 4.10581 9.01435 4.08331 9.99935 4.08331C10.9835 4.08331 12.1335 4.10581 13.2593 4.13748C15.6352 4.20498 16.8235 4.23831 17.5777 5.01498C18.3327 5.79081 18.3327 6.99831 18.3327 9.40998V10.5891C18.3327 13.0025 18.3327 14.2083 17.5785 14.985C16.8235 15.7608 15.636 15.795 13.2593 15.8616C12.1343 15.8941 10.9843 15.9166 9.99935 15.9166C8.91248 15.9134 7.82571 15.895 6.73935 15.8616C4.36352 15.795 3.17518 15.7616 2.42018 14.985C1.66602 14.2083 1.66602 13.0016 1.66602 10.59V10.5891Z"
                  stroke="white"
                  stroke-width="1.25"
                />
                <path
                  d="M4.60953 4.33919C6.91911 4.22419 8.71536 4.16669 9.9987 4.16669C11.282 4.16669 13.0791 4.22419 15.3899 4.3396C15.9946 4.36978 16.5678 4.61838 17.0031 5.03924C17.4384 5.46009 17.7061 6.0246 17.7566 6.62794C17.8624 7.8921 17.9154 9.00544 17.9154 9.96835C17.9154 10.9429 17.8612 12.0717 17.7529 13.355C17.7026 13.9514 17.44 14.51 17.0128 14.9292C16.5856 15.3485 16.0222 15.6005 15.4249 15.6396C13.4495 15.7688 11.6408 15.8334 9.9987 15.8334C8.35703 15.8334 6.5487 15.7688 4.57453 15.6396C3.97748 15.6006 3.41423 15.3487 2.98707 14.9297C2.55992 14.5107 2.29719 13.9525 2.24661 13.3563C2.13703 12.0634 2.08203 10.9338 2.08203 9.96835C2.08203 9.01419 2.13578 7.90044 2.24245 6.62669C2.29315 6.0235 2.56098 5.45919 2.99622 5.03851C3.43146 4.61782 4.00455 4.36934 4.60911 4.33919H4.60953Z"
                  stroke="white"
                  stroke-width="1.66667"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.75 8.17085V11.8358C8.74997 11.9004 8.76744 11.9637 8.80055 12.0191C8.83365 12.0745 8.88115 12.1199 8.938 12.1505C8.99485 12.1811 9.05892 12.1957 9.1234 12.1927C9.18787 12.1898 9.25034 12.1694 9.30417 12.1338L12.0529 10.3171C12.102 10.2847 12.1424 10.2407 12.1704 10.1889C12.1984 10.1372 12.2132 10.0793 12.2134 10.0205C12.2137 9.96163 12.1994 9.90364 12.1718 9.85166C12.1443 9.79968 12.1043 9.75531 12.0554 9.72251L9.30625 7.87418C9.25252 7.83808 9.18999 7.81725 9.12534 7.81394C9.06069 7.81063 8.99636 7.82496 8.93923 7.85539C8.88209 7.88582 8.8343 7.93121 8.80097 7.9867C8.76764 8.04219 8.75002 8.1057 8.75 8.17043V8.17085Z"
                  stroke="white"
                  stroke-width="1.42875"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
            &nbsp;&nbsp;
            <a href="https://www.instagram.com/wyngs_my facebook">
              <svg
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0006 5.99411C7.78378 5.99411 5.99472 7.78317 5.99472 9.99997C5.99472 12.2168 7.78378 14.0058 10.0006 14.0058C12.2174 14.0058 14.0064 12.2168 14.0064 9.99997C14.0064 7.78317 12.2174 5.99411 10.0006 5.99411ZM10.0006 12.6035C8.56699 12.6035 7.39707 11.4336 7.39707 9.99997C7.39707 8.56638 8.56699 7.39645 10.0006 7.39645C11.4342 7.39645 12.6041 8.56638 12.6041 9.99997C12.6041 11.4336 11.4342 12.6035 10.0006 12.6035ZM14.1705 4.89645C13.6529 4.89645 13.235 5.31442 13.235 5.832C13.235 6.34958 13.6529 6.76755 14.1705 6.76755C14.6881 6.76755 15.1061 6.35153 15.1061 5.832C15.1062 5.7091 15.0821 5.58738 15.0351 5.4738C14.9882 5.36023 14.9193 5.25703 14.8324 5.17013C14.7455 5.08322 14.6423 5.01432 14.5287 4.96736C14.4151 4.92039 14.2934 4.8963 14.1705 4.89645ZM17.8092 9.99997C17.8092 8.92185 17.8189 7.85349 17.7584 6.77731C17.6978 5.52731 17.4127 4.41794 16.4986 3.50388C15.5826 2.58786 14.4752 2.30466 13.2252 2.24411C12.1471 2.18356 11.0787 2.19333 10.0025 2.19333C8.92441 2.19333 7.85605 2.18356 6.77988 2.24411C5.52988 2.30466 4.4205 2.58981 3.50644 3.50388C2.59042 4.41989 2.30722 5.52731 2.24667 6.77731C2.18613 7.85544 2.19589 8.9238 2.19589 9.99997C2.19589 11.0761 2.18613 12.1465 2.24667 13.2226C2.30722 14.4726 2.59238 15.582 3.50644 16.4961C4.42246 17.4121 5.52988 17.6953 6.77988 17.7558C7.858 17.8164 8.92636 17.8066 10.0025 17.8066C11.0807 17.8066 12.149 17.8164 13.2252 17.7558C14.4752 17.6953 15.5846 17.4101 16.4986 16.4961C17.4146 15.58 17.6978 14.4726 17.7584 13.2226C17.8209 12.1465 17.8092 11.0781 17.8092 9.99997ZM16.0904 14.6054C15.9478 14.9609 15.776 15.2265 15.5006 15.5C15.2252 15.7754 14.9615 15.9472 14.606 16.0898C13.5787 16.498 11.1393 16.4062 10.0006 16.4062C8.86191 16.4062 6.4205 16.498 5.39316 16.0918C5.03769 15.9492 4.77207 15.7773 4.49863 15.5019C4.22324 15.2265 4.05136 14.9629 3.90878 14.6074C3.50253 13.5781 3.59433 11.1386 3.59433 9.99997C3.59433 8.8613 3.50253 6.41989 3.90878 5.39255C4.05136 5.03708 4.22324 4.77146 4.49863 4.49802C4.77402 4.22458 5.03769 4.05075 5.39316 3.90817C6.4205 3.50192 8.86191 3.59372 10.0006 3.59372C11.1393 3.59372 13.5807 3.50192 14.608 3.90817C14.9635 4.05075 15.2291 4.22263 15.5025 4.49802C15.7779 4.77341 15.9498 5.03708 16.0924 5.39255C16.4986 6.41989 16.4068 8.8613 16.4068 9.99997C16.4068 11.1386 16.4986 13.5781 16.0904 14.6054Z"
                  fill="white"
                />
                <path
                  d="M10.0006 5.99411C7.78378 5.99411 5.99472 7.78317 5.99472 9.99997C5.99472 12.2168 7.78378 14.0058 10.0006 14.0058C12.2174 14.0058 14.0064 12.2168 14.0064 9.99997C14.0064 7.78317 12.2174 5.99411 10.0006 5.99411ZM10.0006 12.6035C8.56699 12.6035 7.39707 11.4336 7.39707 9.99997C7.39707 8.56638 8.56699 7.39645 10.0006 7.39645C11.4342 7.39645 12.6041 8.56638 12.6041 9.99997C12.6041 11.4336 11.4342 12.6035 10.0006 12.6035ZM14.1705 4.89645C13.6529 4.89645 13.235 5.31442 13.235 5.832C13.235 6.34958 13.6529 6.76755 14.1705 6.76755C14.6881 6.76755 15.1061 6.35153 15.1061 5.832C15.1062 5.7091 15.0821 5.58738 15.0351 5.4738C14.9882 5.36023 14.9193 5.25703 14.8324 5.17013C14.7455 5.08322 14.6423 5.01432 14.5287 4.96736C14.4151 4.92039 14.2934 4.8963 14.1705 4.89645ZM17.8092 9.99997C17.8092 8.92185 17.8189 7.85349 17.7584 6.77731C17.6978 5.52731 17.4127 4.41794 16.4986 3.50388C15.5826 2.58786 14.4752 2.30466 13.2252 2.24411C12.1471 2.18356 11.0787 2.19333 10.0025 2.19333C8.92441 2.19333 7.85605 2.18356 6.77988 2.24411C5.52988 2.30466 4.4205 2.58981 3.50644 3.50388C2.59042 4.41989 2.30722 5.52731 2.24667 6.77731C2.18613 7.85544 2.19589 8.9238 2.19589 9.99997C2.19589 11.0761 2.18613 12.1465 2.24667 13.2226C2.30722 14.4726 2.59238 15.582 3.50644 16.4961C4.42246 17.4121 5.52988 17.6953 6.77988 17.7558C7.858 17.8164 8.92636 17.8066 10.0025 17.8066C11.0807 17.8066 12.149 17.8164 13.2252 17.7558C14.4752 17.6953 15.5846 17.4101 16.4986 16.4961C17.4146 15.58 17.6978 14.4726 17.7584 13.2226C17.8209 12.1465 17.8092 11.0781 17.8092 9.99997ZM16.0904 14.6054C15.9478 14.9609 15.776 15.2265 15.5006 15.5C15.2252 15.7754 14.9615 15.9472 14.606 16.0898C13.5787 16.498 11.1393 16.4062 10.0006 16.4062C8.86191 16.4062 6.4205 16.498 5.39316 16.0918C5.03769 15.9492 4.77207 15.7773 4.49863 15.5019C4.22324 15.2265 4.05136 14.9629 3.90878 14.6074C3.50253 13.5781 3.59433 11.1386 3.59433 9.99997C3.59433 8.8613 3.50253 6.41989 3.90878 5.39255C4.05136 5.03708 4.22324 4.77146 4.49863 4.49802C4.77402 4.22458 5.03769 4.05075 5.39316 3.90817C6.4205 3.50192 8.86191 3.59372 10.0006 3.59372C11.1393 3.59372 13.5807 3.50192 14.608 3.90817C14.9635 4.05075 15.2291 4.22263 15.5025 4.49802C15.7779 4.77341 15.9498 5.03708 16.0924 5.39255C16.4986 6.41989 16.4068 8.8613 16.4068 9.99997C16.4068 11.1386 16.4986 13.5781 16.0904 14.6054Z"
                  fill="white"
                />
              </svg>
            </a>
            &nbsp;&nbsp;
            <a href="https://www.facebook.com/WYNGSMALAYSIA">
              <svg
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 2.5C5.865 2.5 2.5 5.865 2.5 10C2.5 14.135 5.865 17.5 10 17.5C14.135 17.5 17.5 14.135 17.5 10C17.5 5.865 14.135 2.5 10 2.5ZM10 3.75C13.4594 3.75 16.25 6.54063 16.25 10C16.2515 11.4962 15.715 12.9431 14.7383 14.0766C13.7617 15.2101 12.41 15.9547 10.93 16.1744V11.8225H12.71L12.9894 10.0144H10.93V9.02688C10.93 8.27688 11.1769 7.61 11.8787 7.61H13.0069V6.0325C12.8088 6.00563 12.3894 5.9475 11.5969 5.9475C9.94187 5.9475 8.97187 6.82125 8.97187 8.8125V10.0144H7.27063V11.8225H8.97187V16.1588C7.51234 15.9185 6.18577 15.1672 5.22918 14.039C4.27259 12.9108 3.74831 11.4792 3.75 10C3.75 6.54063 6.54063 3.75 10 3.75Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>{" "}
        </Col>
      </Row>
    </div>
  );
};

const Header = (props) => {
  const [selectedValue, setSelectedValue] = useState(options[0]);
  const { height, width } = useWindowDimensions();
  const [about, setAbout] = useState(false);
  const [product, setProduct] = useState(false);
  const [automotive, setAutomotive] = useState(false);
  const [nonautomotive, setNonAutomotive] = useState(false);
  const [infra, setInfra] = useState(false);
  const [add, setAdd] = useState(false);
  const { t, i18n } = useTranslation();
  const handleSelectChange = (selectedOption) => {
    setSelectedValue(selectedOption);
    i18n.changeLanguage(selectedOption.value);
  };

  const languageOptions = [
    { value: "en", label: "English", countryCode: "US" },
    { value: "ml", label: "Malay", countryCode: "MY" },
    { value: "md", label: "Mandarin", countryCode: "CN" },
    { value: "dt", label: "Dutch", countryCode: "NL" },
    // Add more language options as needed
  ];

  const closedrawer = () => {
    setAbout(false);
    setProduct(false);
    setAutomotive(false);
    setNonAutomotive(false);
    setInfra(false);
    document.getElementById("nav-links").classList.toggle("nav-active");
    document.getElementById("hambuger").classList.toggle("toggle");
    document.getElementById("root").classList.toggle("active");
  };

  const burgerClick = () => {
    document.getElementById("nav-links").classList.toggle("nav-active");
    document.getElementById("hambuger").classList.toggle("toggle");
    document.getElementById("root").classList.toggle("active");

    if (add !== true) {
      setAbout(false);
      setProduct(false);
      setAutomotive(false);
      setNonAutomotive(false);
      setInfra(false);
    }
    setAdd(!add);
  };

  const changeLanguage = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  const [isFixed, setIsFixed] = useState(false);

  // useEffect(() => {
  // 	const handleScroll = () => {
  // 		if (window.scrollY > 100) {
  // 			// Change the threshold as needed
  // 			setIsFixed(true)
  // 		} else {
  // 			setIsFixed(false)
  // 		}
  // 	}

  // 	window.addEventListener('scroll', handleScroll)

  // 	return () => {
  // 		window.removeEventListener('scroll', handleScroll)
  // 	}
  // }, [])

  if (props?.new && width > 999) {
    return (
      <>
        <CommonHeader />
        <div className="header new ">
          <nav className="headerContainer">
            <div className="d-f j-c a-c">
              <div className="logoContainer">
                <Link to="/">
                  <img className="logo fluid" src={bigLogo} />
                </Link>
              </div>
            </div>
            <ul id="nav-links" className="nav-links">
              <>
                <li>
                  <div className="signUpstyle">
                    <Link to="/login">
                      {t("Login")}/{t("Sign Up")}
                    </Link>
                  </div>
                </li>
                <li className="hvOff">
                  <div>
                    <Select
                      value={selectedValue}
                      options={options}
                      defaultValue={options[0]}
                      onChange={handleSelectChange}
                      getOptionLabel={(option) => (
                        <div>
                          <img
                            src={option.src}
                            alt={option.alt}
                            style={{
                              width: "2em", // Set to full width
                              height: "auto", // Maintain aspect ratio
                            }}
                          />
                        </div>
                      )}
                      styles={customStyles}
                    />
                  </div>
                </li>
              </>
            </ul>
            <div className={`RedNavBar d-f jc-sb ${isFixed ? "fixed" : ""}`}>
              <div className="d-f">
                <li>
                  <Link to="/service">{t("Services")}</Link>
                </li>
                <li>
                  <Link to="/support">{t("Support?")}</Link>
                </li>

                <li>
                  <Link to="/careers">{t("careers")}</Link>
                </li>
                <li>
                  <Link to="/about">{t("Who are you?")}</Link>
                </li>
              </div>
              <div>
                <Link to="/how-to-use">
                  <Button orange={true} title={t("How to use WYNGS?")} />
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="header">
        <nav className="headerContainer">
          <div className="d-f j-c a-c">
            <div className="logoContainer">
              <Link to="/">
                <img className="logo fluid" src={logo} />
              </Link>
            </div>
            {/* <div className='txt'>Wyngs</div> */}

            {width > 999 && <div className="Sline"></div>}

            <ul id="nav-links" className="nav-links">
              {width > 999 ? (
                <>
                  <li>
                    <Link to="/about">{t("Who are you?")}</Link>
                  </li>
                  <li>
                    <Link to="/service">{t("Services")}</Link>
                  </li>
                  <li>
                    <Link to="/support">{t("Support?")}</Link>
                  </li>

                  <li>
                    <Link to="/careers">{t("careers")}</Link>
                  </li>
                </>
              ) : (
                <div className="headerMobile">
                  <li className="mobileli">
                    <div className="d-f jc-sb">
                      <Link
                        onClick={closedrawer}
                        to="/about"
                        className="aboutUsMobile"
                      >
                        {t("Who are you?")}
                      </Link>
                    </div>
                  </li>
                  <li className="mobileli">
                    <div className="d-f jc-sb">
                      <Link
                        onClick={closedrawer}
                        to="/service"
                        className="aboutUsMobile"
                      >
                        {t("Services")}
                      </Link>
                    </div>
                  </li>
                  <li className="mobileli">
                    <div className="d-f jc-sb">
                      <Link
                        onClick={closedrawer}
                        to="/support"
                        className="aboutUsMobile"
                      >
                        {t("Support?")}
                      </Link>
                    </div>
                  </li>
                  <li className="mobileli">
                    <div className="d-f jc-sb">
                      <Link
                        onClick={closedrawer}
                        to="/careers"
                        className="aboutUsMobile"
                      >
                        {t("careers")}
                      </Link>
                    </div>
                  </li>

                  <li className="mobileli">
                    <div className="d-f jc-sb">
                      <Link
                        onClick={closedrawer}
                        to="/login"
                        className="aboutUsMobile"
                      >
                        {t("Login")}/{t("Sign Up")}
                      </Link>
                    </div>
                  </li>
                  <li className="mobileli">
                    <div>
                      <Select
                        value={selectedValue}
                        options={options}
                        defaultValue={options[0]}
                        onChange={handleSelectChange}
                        getOptionLabel={(option) => (
                          <div className="d-f   a-c">
                            <img
                              src={option.src}
                              alt={option.alt}
                              style={{
                                width: "2em", // Set to full width
                                height: "auto", // Maintain aspect ratio
                              }}
                            />

                            <div
                              style={{
                                paddingLeft: "2em",
                                fontSize: "15px",
                              }}
                            >
                              {option.label}
                            </div>
                          </div>
                        )}
                        styles={customStyles}
                      />
                    </div>
                  </li>
                </div>
              )}
            </ul>
          </div>

          {width > 999 && (
            <ul id="nav-links" className="nav-links">
              <>
                <li>
                  <Link to="/login">
                    {t("Login")}/{t("Sign Up")}
                  </Link>
                </li>
                <li className="hvOff">
                  <div>
                    <Select
                      value={selectedValue}
                      options={options}
                      defaultValue={options[0]}
                      onChange={handleSelectChange}
                      getOptionLabel={(option) => (
                        <div>
                          <img
                            src={option.src}
                            alt={option.alt}
                            style={{
                              width: "2em", // Set to full width
                              height: "auto", // Maintain aspect ratio
                            }}
                          />
                        </div>
                      )}
                      styles={customStyles}
                    />
                  </div>
                </li>
              </>
            </ul>
          )}

          <div id="hambuger" className="burger" onClick={burgerClick}>
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
